import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { EmpresaAuthProvider } from './contexts/EmpresaAuthContext';
import { StaffAuthProvider } from './contexts/StaffAuthContext';
import { PromoterAuthProvider } from './contexts/PromoterAuthContext';
import ErrorBoundary from './components/shared/ErrorBoundary/ErrorBoundary';
import './styles/globals.css';

// User Pages
import UserHome from './pages/user/Home/Home';
import UserLogin from './pages/user/Login/Login';
import UserRegister from './pages/user/Register/Register';
import Search from './pages/user/Search/Search';
import ActivityDetail from './pages/user/ActivityDetail/ActivityDetail';
import Checkout from './pages/user/Checkout/Checkout';
import BookingConfirmed from './pages/user/BookingConfirmed/BookingConfirmed';
import Profile from './pages/user/Profile/Profile';
import EmpresaPublic from './pages/user/EmpresaPublic/EmpresaPublic';

// Empresa Pages
import EmpresaHome from './pages/empresa/EmpresaHome/EmpresaHome';
import EmpresaLogin from './pages/empresa/Login/Login';
import EmpresaRegister from './pages/empresa/Register/Register';
import EmpresaDashboard from './pages/empresa/Dashboard/Dashboard';
import EmpresaActivities from './pages/empresa/Activities/Activities';
import EmpresaReservations from './pages/empresa/Reservations/Reservations';
import QRScanner from './pages/empresa/QRScanner/QRScanner';
import EmpresaSettings from './pages/empresa/Settings/Settings';
import EmpresaStaff from './pages/empresa/Staff/Staff';
import EmpresaPromoters from './pages/empresa/Promoters/EmpresaPromoters';

// Ventas en persona (dueño y operador)
import Sell from './pages/sales/Sell';
import SalesList from './pages/sales/SalesList';

// Staff Pages
import StaffLogin from './pages/staff/Login/StaffLogin';
import StaffScanner from './pages/staff/Scanner/StaffScanner';

// Promotor Pages (promotor persona; la empresa promotora entra por /empresa/promotor)
import PromoterRegister from './pages/promoter/PromoterRegister';
import PromoterLogin from './pages/promoter/PromoterLogin';
import PromoterHome from './pages/promoter/PromoterHome';

// Admin Pages
import AdminLogin from './pages/admin/Login/AdminLogin';
import AdminPanel from './pages/admin/Panel/AdminPanel';

// 404 Page
import NotFound from './pages/NotFound/NotFound';

function App() {
  return (
    <ErrorBoundary>
    <div className="App">
      <Router>
        <AuthProvider>
          <EmpresaAuthProvider>
          <StaffAuthProvider>
          <PromoterAuthProvider>
            <Routes>
              {/* User Routes */}
              <Route path="/" element={<UserHome />} />
              <Route path="/login" element={<UserLogin />} />
              <Route path="/register" element={<UserRegister />} />
              <Route path="/search" element={<Search />} />
              <Route path="/activity/:id" element={<ActivityDetail />} />
              <Route path="/checkout/:id" element={<Checkout />} />
              <Route path="/booking-confirmed" element={<BookingConfirmed />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/empresas/:slug" element={<EmpresaPublic />} />
              
              {/* Empresa Routes */}
              <Route path="/empresa" element={<EmpresaHome />} />
              <Route path="/empresa/login" element={<EmpresaLogin />} />
              <Route path="/empresa/register" element={<EmpresaRegister />} />
              <Route path="/empresa/dashboard" element={<EmpresaDashboard />} />
              <Route path="/empresa/activities" element={<EmpresaActivities />} />
              <Route path="/empresa/reservations" element={<EmpresaReservations />} />
              <Route path="/empresa/scanner" element={<QRScanner mode="empresa" />} />
              <Route path="/empresa/settings" element={<EmpresaSettings />} />
              <Route path="/empresa/staff" element={<EmpresaStaff />} />
              <Route path="/empresa/sales/new" element={<Sell mode="empresa" />} />
              <Route path="/empresa/sales" element={<SalesList mode="empresa" />} />
              <Route path="/empresa/promotores" element={<EmpresaPromoters />} />
              <Route path="/empresa/promotor" element={<PromoterHome mode="empresa" />} />

              {/* Staff Routes (login y escáner del equipo de una empresa) */}
              <Route path="/staff/login" element={<StaffLogin />} />
              <Route path="/staff/scanner" element={<StaffScanner />} />
              <Route path="/staff/sales/new" element={<Sell mode="staff" />} />
              <Route path="/staff/sales" element={<SalesList mode="staff" />} />

              {/* Promotor Routes (persona, con su propio token) */}
              <Route path="/promotor/register" element={<PromoterRegister />} />
              <Route path="/promotor/login" element={<PromoterLogin />} />
              <Route path="/promotor" element={<PromoterHome mode="persona" />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminPanel />} />

              {/* 404 Route - DEBE IR AL FINAL */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </PromoterAuthProvider>
          </StaffAuthProvider>
          </EmpresaAuthProvider>
        </AuthProvider>
      </Router>
    </div>
    </ErrorBoundary>
  );
}

export default App;